import React, { FunctionComponent } from 'react'
import NextImage, { ImageProps } from 'next/image'
import clsx from 'clsx'

const Image: FunctionComponent<
  {
    width?: string
    height?: string
  } & Omit<ImageProps, 'width' | 'height'>
> = ({ width, height, src, ...props }: any) => {
  const isSrcObject = typeof src === 'object'

  const wrapperStyle = {
    width: width || 'auto',
    height: height || 'auto',
    minWidth: width || 'auto',
    minHeight: height || 'auto',
    maxWidth: width || 'auto',
    maxHeight: height || 'auto',
  }

  return (
    <div style={wrapperStyle}>
      <NextImage
        {...props}
        src={src}
        placeholder={isSrcObject ? 'blur' : undefined}
        fill
        className={clsx(
          '!relative object-contain w-full !h-auto',
          props.className
        )}
      />
    </div>
  )
}

export default Image
